var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"horizontal-menu"},_vm._l((_vm.menuItems),function(ref){
var text = ref.text;
var menuItem = ref.menuItem;
return _c('li',{key:text,staticClass:"horizontal-menu-item"},[_c('button',{class:[
        'horizontal-menu-button',
        {
          'horizontal-menu-button_active': _vm.activeMenuItem === menuItem,
        } ],on:{"click":function($event){return _vm.$emit('onMenuItemChange', menuItem)}}},[_vm._v("\n      "+_vm._s(text)+"\n    ")])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }